export const booleanOptions = [
    { label: 'true', value: true },
    { label: 'false', value: false },
];

export const statusOptions = [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'New' },
    { value: 2, label: 'Sent to Clearing' },
    { value: 3, label: 'Approved' },
    { value: 4, label: 'Rejected' },
    { value: 5, label: 'Restricted' },
    { value: 6, label: 'Suspended' },
    { value: 7, label: 'Closed' },
];

export const marginTypesOptions = [
    { label: 'None', value: 0 },
    { label: 'Cash', value: 1 },
    { label: 'Margin', value: 2 },
    { label: 'Day Trader', value: 4 },
    { label: 'Margin Ira', value: 8 },
];

export const liquidityNeedsOptions = [
    { label: 'Very Important', value: 'VERY_IMPORTANT' },
    { label: 'Somewhat Important', value: 'SOMEWHAT_IMPORTANT' },
    { label: 'Not Important', value: 'NOT_IMPORTANT' },
];

export const timeHorizonOptions = [
    { label: 'Short (Less than 3 Years)', value: 'SHORT' },
    { label: 'Average (4-7 Years)', value: 'AVERAGE' },
    { label: 'Long (8 Years+)', value: 'LONG' },
];

export const investmentExperienceOptions = [
    { label: 'None', value: 'None' },
    { label: 'Limited (1-2 Years)', value: 'Limited' },
    { label: 'Good (3-5 Years)', value: 'Good' },
    { label: 'Extensive (5 years or more)', value: 'Extensive' },
];

export const investmentObjectivesOptions = [
    { label: 'Capital Preservation', value: 'CAPITAL_PRESERVATION' },
    { label: 'Growth', value: 'GROWTH' },
    { label: 'Growth Income', value: 'GROWTH_INCOME' },
    { label: 'Balanced', value: 'BALANCED' },
    { label: 'Income', value: 'INCOME' },
    { label: 'Speculation', value: 'SPECULATION' },
    { label: 'Maximum Growth', value: 'MAXIMUM_GROWTH' },
    { label: 'Other', value: 'OTHER' },
];

export const riskToleranceOptions = [
    { label: 'Low', value: 'Low' },
    { label: 'Medium', value: 'Medium' },
    { label: 'High', value: 'High' },
];

export const annualIncomeOptions = [
    { label: 'Under $25,000', value: '25,000' },
    { label: '$25,001 - $50,000', value: '25,001-50,000' },
    { label: '$50,001 - $100,000', value: '50,001-100,000' },
    { label: '$100,001 - $200,000', value: '100,001-200,000' },
    { label: '$200,001 - $300,000', value: '200,001-300,000' },
    { label: '$300,001 - $500,000', value: '300,001-500,000' },
    { label: '$500,001 - $1,200,000', value: '500,001-1,200,000' },
    { label: 'Over $1,200,000', value: '1,200,000' },
];
